<script lang="ts">
  import ChatWithSupportLink from "@shared/svelte/Components/ChatWithSupportLink.svelte";

  const companyName = (window as any).C.COMPANY_NAME;

</script>

<div class="fizz-text-center fizz-stack-24 fizz-text-subdued">
  <p class="fizz-stack-16">
    *Monetary values calculated from list price or otherwise entered custom price.
  </p>
  <p>
    Questions or feedback about the free {companyName} Report?
  </p>
  <p>
    <ChatWithSupportLink message={"Chat with Support"} brandprimary={true} />
  </p>
</div>
